// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  capturePointId: __t.string().primaryKey().name("capture_point_id"),
  matchId: __t.string().name("match_id"),
  structureIndex: __t.u32().name("structure_index"),
  owner: __t.option(__t.u32()),
  progress: __t.f64(),
  capturingTeam: __t.option(__t.u32()).name("capturing_team"),
  holdCounter: __t.u32().name("hold_counter"),
});
